import { render, staticRenderFns } from "./AMCCourse.vue?vue&type=template&id=61388046&scoped=true"
import script from "./AMCCourse.vue?vue&type=script&lang=js"
export * from "./AMCCourse.vue?vue&type=script&lang=js"
import style0 from "./AMCCourse.vue?vue&type=style&index=0&id=61388046&prod&scoped=true&lang=css"
import style1 from "./AMCCourse.vue?vue&type=style&index=1&id=61388046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61388046",
  null
  
)

export default component.exports